<app-header></app-header>
<div id="main_app" class="container-fluid">
  <div class="container">
    <div id="pomodoro_timer" class="timer-r" [ngClass]="{'break': pomodoroRepository.isBreak}">
      <div class="pomodoro_count" *ngIf="!haveToken && !pomodoroRepository.isBreak">{{ 'Pomodoro' | translate }} {{ pomodoroRepository.todayPomodoroCount }}</div>
      <div class="pomodoro_count" *ngIf="!haveToken && pomodoroRepository.isBreak">{{ 'Pomodoro' | translate }} {{ pomodoroRepository.todayPomodoroCount - 1 }}</div>
      <div class="pomodoro_count" *ngIf="haveToken && !pomodoroRepository.isBreak">{{ 'Pomodoro' | translate }} {{ pomodoroRepository.pomoCount }}</div>
      <div class="pomodoro_count" *ngIf="haveToken && pomodoroRepository.isBreak">{{ 'Pomodoro' | translate }} {{ pomodoroRepository.pomoCount }}</div>
      <div class="ctl-four-helper" *ngIf="pomodoroRepository.ctlFour">
        <div class="step-title">قدم چهارم</div>
        <p>از اینجا میتونی بفهمی چندمین کاریه که داری با پومودورو انجام میدی.</p>
        <div class="step-counter">4/10</div>
        <div class="row">
          <button class="btn-got-it" (click)="fourToFive()">اتمام</button>
          <button class="btn-got-it" (click)="fourToThree()">برگرد عقب نفهمیدم</button>
        </div>
      </div>
      <div class="timer">{{ pomodoroRepository.getTimerString() }}</div>
      <div class="current_task" *ngIf="!pomodoroRepository.isBreak">{{pomodoroRepository.getFirst().description}}</div>
      <div class="current_task" *ngIf="!haveToken && pomodoroRepository.isBreak">{{ 'Break' | translate }} {{pomodoroRepository.todayPomodoroCount - 1}}</div>
      <div class="current_task" *ngIf="haveToken && pomodoroRepository.isBreak">{{ 'Break' | translate }} {{pomodoroRepository.pomoCount}}</div>
      <div class="buttons_timer">
        <ng-container *ngIf="pomodoroRepository.status === 'stop'">
          <button (click)="pomodoroRepository.start()" class="start_button" [ngClass]="{'break-btn': pomodoroRepository.isBreak}">{{ 'Start' | translate }}</button>
          <div class="ctl-one-helper" *ngIf="pomodoroRepository.ctlTwo">
            <div class="step-title">قدم دوم</div>
            <p>از اینجا میتونی دکمه پومودورو تو استارت بزنی.</p>
            <div class="step-counter">2/10</div>
            <div class="row">
              <button class="btn-got-it" (click)="secondToThird()">فهمیدم</button>
              <button class="btn-got-it" (click)="secondToFirst()">برگرد عقب نفهمیدم</button>
            </div>
          </div>
        </ng-container>
        <button *ngIf="!pomodoroRepository.isBreak" (click)="pomodoroRepository.restart()" class="reset_button"
                [ngStyle]="{'cursor':pomodoroRepository.reo()}"
                [disabled]="pomodoroRepository.status === 'stop' && pomodoroRepository.isBreak === false">{{ 'Restart' | translate }}
        </button>
        <div class="ctl-one-helper intro-three" *ngIf="pomodoroRepository.ctlThree">
          <div class="step-title">قدم سوم</div>
          <p>اگه وسط زمان پومودرو حواست پرت شد، میتونی ازینجا تایمر رو ریست کنی.</p>
          <div class="step-counter">3/10</div>
          <div class="row">
            <button class="btn-got-it" (click)="thirdToFour()">فهمیدم</button>
            <button class="btn-got-it" (click)="thirdToSecond()">برگرد عقب نفهمیدم</button>
          </div>
        </div>
        <button *ngIf="pomodoroRepository.isBreak" (click)="pomodoroRepository.restart()" class="reset_button"
                [ngStyle]="{'cursor':pomodoroRepository.reo()}"
                [disabled]="pomodoroRepository.status === 'stop' && pomodoroRepository.isBreak === false">{{ 'Skip' | translate }}
        </button>
      </div>
    </div><!-- #pomodoro_timer -->
    <div class="ctl-one-helper" *ngIf="pomodoroRepository.ctlOne">
      <span (click)="endTour()">&times;</span>
      <div class="step-title">قدم اول</div>
      <p>این قسمت نشان دهنده ی زمان تایمر پومودوروی شماست.</p>
      <div class="step-counter">1/10</div>
      <div class="row">
        <button class="btn-got-it" (click)="firstToSecond()">فهمیدم</button>
      </div>
    </div>
    <div id="todo">
      <div class="main_title"><i class="icon-clipboard"></i>{{ 'TodoList' | translate }} | <span class="getfo">{{pomodoroRepository.getAllToDoPomodoro()}}
        / {{ pomodoroRepository.getSumOfDurationsTodo() }}</span></div>
      <div class="add_new_task">
        <form action="">
          <div class="cat_task">
            <input (change)="saveToCategories(this.myControl.value)" type="text" placeholder="{{ 'Category' | translate }}"
                   aria-label="Number" matInput [formControl]="myControl" [matAutocomplete]="auto"
                   [(ngModel)]="pomodoro.category" value="category">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let category of pomodoroRepository.categories" [value]="category">
                {{category}}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="title_task">
            <input type="text" class="cat_task" [value]="pomodoro.description" placeholder="{{ 'ShortDescription' | translate }}"
                   [(ngModel)]="pomodoro.description" name="task.description" (keyup.enter)="addItem()">
          </div>
          <div class="add_task_button">
            <button type="button" (click)="addItem()"><i class="icon-plus"></i></button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div><!-- .add_new_task -->
      <div class="todolist">
        <div class="header_task">
          <div class="col_task col_task1"><i class="icon-list-ul"></i>{{ 'Category' | translate }}</div>
          <div class="col_task col_task2"><i class="icon-bookmark"></i>{{ 'ShortDescription' | translate }}</div>
          <div class="clearfix"></div>
        </div><!-- .task -->
        <div class="drag-drop example-list" cdkDropList #todoList="cdkDropList"
             [cdkDropListData]="pomodoroRepository.getTodoPomodoros()"
             [cdkDropListConnectedTo]="[todoList]"
             (cdkDropListDropped)="drop($event)">
          <div class="task" *ngFor="let item of pomodoroRepository.getTodoPomodoros()" title="{{ 'clickToEdit' | translate }}" cdkDrag>
            <div *ngIf="!item.isEdit" (click)="showInput(item)" class="col_task col_task1">{{item.category}}</div>
            <div *ngIf="item.isEdit" (change)="saveToCategories(item.category)" (keyup.enter)="backToDes(item)" class="col_task col_task1">
              <input type="text" id="categ" class="new-cat" (blur)="changeDes(item)" (keyup.enter)="changeDes(item)" placeholder="{{ 'Category' | translate }}"
                     [(ngModel)]="item.category" name="task.category" matInput [formControl]="myControl" [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let category of pomodoroRepository.categories" [value]="category">
                  {{category}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col_task col_task2">
              <div *ngIf="!item.isEdit" (click)="showInput(item)">{{item.description}}</div>
              <div *ngIf="item.isEdit">
                <input type="text" id="desc" (keyup.enter)="backToDes(item)" class="edit-input" (blur)="backToDes(item)" placeholder="{{ 'Title' | translate }}"
                       [(ngModel)]="item.description" name="task.description">
              </div>
            </div>
            <div class="col_task col_task3" title="{{ 'TaskFinishTime' | translate }}">{{ pomodoroRepository.getPomoToDoDoneTime(item) }}</div>
            <div class="col_task col_task4">
              <button class="count_pomodoro" title="{{ 'increasePomodoroCount' | translate }}"
                      (click)="increaseCount(item)">{{item.count}}</button>
            </div>
            <div class="col_task col_task5">
              <button [matMenuTriggerFor]="menu" class="more_option_button"
                      title="{{ 'OpenMenu' | translate }}">
                <i class="icon-ellipsis-h-alt"></i>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="increaseCount(item)">
                  <mat-icon>add_circle_outline</mat-icon>
                  <span class="icon-txt">{{ 'increasePomodoroCount' | translate }}</span>
                </button>
                <button mat-menu-item (click)="decreaseCount(item)">
                  <mat-icon>remove_circle_outline</mat-icon>
                  <span class="icon-txt">{{ 'decreasePomodoroCount' | translate }}</span>
                </button>
                <button mat-menu-item (click)="removeItemFromTodo(item)">
                  <mat-icon>delete_forever</mat-icon>
                  <span class="icon-txt">{{ 'DeleteTask' | translate }}</span>
                </button>
                <button mat-menu-item (click)="changeDes(item)">
                  <mat-icon>create</mat-icon>
                  <span class="icon-txt">{{ 'EditTask' | translate }}</span>
                </button>
                <button class="icon-txt" mat-menu-item (click)="pomodoroRepository.done(item)">
                  <mat-icon>check_circle_outline</mat-icon>
                  {{ 'MarkAsDone' | translate }}
                </button>
              </mat-menu>
            </div>
            <div class="clearfix"></div>
          </div><!-- .task -->
        </div>
      </div><!-- .todolist -->
      <div class="todo_footer">
        <span class="todo_footer" *ngIf="pomodoroRepository.getAllToDoPomodoro() > 3">
          <i class="icon-coffee-togo"></i>
          {{ 'NextLongBreak' | translate }}
          {{pomodoroRepository.getNextLongBreakTime()}}
          | </span>
        <i class="icon-clock"></i>{{ 'FinishTime' | translate }}: {{ pomodoroRepository.getPomoToDoDoneTime(pomodoroRepository.getLast()) }}
      </div>
      <div class="help_footer">{{ 'mainPageInfo1' | translate }}
        <!--      </div>-->
      </div><!-- TO DO Section -->
      <div id="done">
        <div class="main_title"><i class="icon-clipboard-check"></i>{{ 'DoneList' | translate }} | <span>{{DoneCounter()}}
          /
        <ng-container *ngIf="!haveToken">
          {{ pomodoroRepository.getSumOfDurationsDone() }}
        </ng-container>
        <ng-container *ngIf="haveToken">
          {{pomodoroRepository.finalDone}}
        </ng-container>
      </span>
        </div>
        <div class="donelist">
          <div class="header_task">
            <div class="col_task col_task1"><i class="icon-list-ul"></i>{{ 'Category' | translate }}</div>
            <div class="col_task col_task2"><i class="icon-bookmark"></i>{{ 'ShortDescription' | translate }}</div>
            <div class="clearfix"></div>
          </div><!-- .task -->
          <div>
            <!--          <div class="task" *ngFor="let item of pomodoroRepository.getDonePomodorosReverse()">-->
            <div class="task" *ngFor="let item of pomodoroRepository.getDonePomodoros()">
              <div class="col_task col_task1">{{item.category}}</div>
              <div class="col_task col_task2">{{item.description}}</div>
              <div class="col_task col_task3" title="{{ 'TaskFinishTime' | translate }}">{{ item.ended_at.substr(10,6) }}</div>
              <div class="col_task col_task4">
                <div class="count_pomodoro" (click)="pomodoroRepository.copyToTodo(item)">
                <span class="material-icons mato-font">
                refresh
                </span>
                </div>
              </div>
              <div class="col_task col_task5">
                <button [matMenuTriggerFor]="menuu" class="more_option_button"
                        title="{{ 'OpenMenu' | translate }}">
                  <i class="icon-ellipsis-h-alt"></i>
                </button>
                <mat-menu #menuu="matMenu">
                  <button mat-menu-item (click)="removeItemFromDone(item)">
                    <mat-icon>delete_forever</mat-icon>
                    <span class="icon-txt">{{ 'DeleteTask' | translate }}</span>
                  </button>
                  <button class="icon-txt" mat-menu-item (click)="pomodoroRepository.copyToTodo(item)">
                    <mat-icon>check_circle_outline</mat-icon>
                    {{ 'MarkAsTodo' | translate }}
                  </button>
                </mat-menu>
              </div>
              <div class="clearfix"></div>
            </div><!-- .task -->
          </div>
        </div><!-- .todolist -->
      </div><!-- Done Section -->
    </div><!-- .container -->
  </div><!-- #main_app -->
  <app-footer></app-footer>
</div>
